// src/components/admin/PendingRequestsNotification.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const PendingRequestsNotification = () => {
  const { user } = useAuth();
  const [pendingRequests, setPendingRequests] = useState(0);

  useEffect(() => {
    if (user?.role === 'superadmin') {
      fetchPendingRequests();
    }
  }, [user]);

  const fetchPendingRequests = async () => {
    try {
      // TODO: Replace with actual API call to get pending user limit requests
      // const response = await subscriptionRequestService.getAllRequests({ 
      //   requestType: 'user_limit_increase', 
      //   status: 'pending' 
      // });
      // setPendingRequests(response.data?.length || 0);
      
      // For now, no mock data - only show real requests
      setPendingRequests(0);
    } catch (error) {
      console.error('Error fetching pending requests:', error);
      setPendingRequests(0);
    }
  };

  if (user?.role !== 'superadmin' || pendingRequests === 0) {
    return null;
  }

  return (
    <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div className="ml-3">
          <p className="text-sm text-orange-700">
            <span className="font-medium">
              {pendingRequests} demande{pendingRequests > 1 ? 's' : ''} d'augmentation de limite d'utilisateurs en attente
            </span>
            {' '}
            <a 
              href="/superadmin/users" 
              className="font-medium underline text-orange-700 hover:text-orange-600"
            >
              Voir les demandes →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingRequestsNotification;